export default __webpack_public_path__ + "static/media/INFICON.ccc1e942.png";